import React, { useEffect, useState } from "react";
import { Transfer, Button, Card, Row, Col, Typography, message, Input } from "antd";
import { SaveOutlined, SearchOutlined } from "@ant-design/icons";
import api from "../../api";

const { Title } = Typography;

const CategorySettings = () => {
  const [categories, setCategories] = useState([]);
  const [selectedHeader, setSelectedHeader] = useState([]);
  const [selectedFooter, setSelectedFooter] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // برای جستجو در ترنسفر
  const [headerSearchText, setHeaderSearchText] = useState('');
  const [footerSearchText, setFooterSearchText] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get(
          "/panel/setting/settingCategory?per_page&page"
        );
        
        if (response.data && response.data.data) {
          const { categories, catHeader, catFooter } = response.data.data;

          // تبدیل داده‌ها به فرمت مورد نیاز Transfer
          const formattedCategories = Array.isArray(categories) ? categories.map((cat) => ({
            key: cat.id.toString(),
            title: cat.name,
            description: cat.seo_description || '',
            disabled: false, // می‌توانید برخی آیتم‌ها را غیرفعال کنید
          })) : [];

          // تنظیم آیتم‌های انتخاب شده در هدر و فوتر
          setCategories(formattedCategories);
          setSelectedHeader(Array.isArray(catHeader) ? catHeader.map((cat) => cat.id.toString()) : []);
          setSelectedFooter(Array.isArray(catFooter) ? catFooter.map((cat) => cat.id.toString()) : []);
        } else {
          message.error("ساختار داده دریافتی معتبر نیست");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("خطا در دریافت اطلاعات: " + (error.message || "خطای نامشخص"));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      const payload = {
        categoryHeader: selectedHeader,
        categoryFooter: selectedFooter,
      };

      await api.post("/panel/setting/storeCategory", payload);
      message.success("تنظیمات با موفقیت ذخیره شد!");
    } catch (error) {
      console.error("Error saving data:", error);
      message.error("خطا در ذخیره‌سازی تنظیمات: " + (error.message || "خطای نامشخص"));
    }
  };

  // فیلتر برای جستجو در ترنسفر
  const filterOption = (inputValue, item) => {
    return item.title.indexOf(inputValue) !== -1;
  };

  return (
    <Card>
      <Title level={3}>تنظیمات دسته‌بندی</Title>

      <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
        <Col span={12}>
          <Card
            title="دسته‌بندی هدر"
            bordered={false}
            style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
          >
            <Transfer
              dataSource={categories}
              targetKeys={selectedHeader}
              onChange={(keys) => setSelectedHeader(keys)}
              render={(item) => item.title}
              listStyle={{ width: "100%", height: "300px" }}
              loading={loading}
              showSearch
              filterOption={filterOption}
              searchPlaceholder="جستجوی دسته‌بندی..."
              locale={{
                itemUnit: "مورد",
                itemsUnit: "مورد",
                searchPlaceholder: "جستجو...",
                notFoundContent: "موردی یافت نشد"
              }}
            />
          </Card>
        </Col>

        <Col span={12}>
          <Card
            title="دسته‌بندی فوتر"
            bordered={false}
            style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
          >
            <Transfer
              dataSource={categories}
              targetKeys={selectedFooter}
              onChange={(keys) => setSelectedFooter(keys)}
              render={(item) => item.title}
              listStyle={{ width: "100%", height: "300px" }}
              loading={loading}
              showSearch
              filterOption={filterOption}
              searchPlaceholder="جستجوی دسته‌بندی..."
              locale={{
                itemUnit: "مورد",
                itemsUnit: "مورد",
                searchPlaceholder: "جستجو...",
                notFoundContent: "موردی یافت نشد"
              }}
            />
          </Card>
        </Col>
      </Row>

      <Button
        type="primary"
        icon={<SaveOutlined />}
        onClick={handleSave}
        style={{ marginTop: "24px", width: "200px" }}
        loading={loading}
        disabled={loading}
      >
        ذخیره تنظیمات
      </Button>
    </Card>
  );
};

export default CategorySettings;